<div class="container-fluid">
    <div class="row">
        <div class="col-xl-12">
            <h1 class="page-hd">Masters <i class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Price Master <i
                    class="fa fa-angle-right hd-icon" aria-hidden="true"></i> Add Price</h1>
            <div class="content-wrap">
                <form [formGroup]="priceForm">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="requestTypeId" class="form-label">Service Name</label>
                                <select formControlName="requestTypeId" class="form-control form-input" id="requestTypeId"
                                [(ngModel)]="price.requestTypeId">
                                    <option value="undefined" disabled selected> Please select Service Name </option>
                                    <option *ngFor="let request of RequestTypeDropDown" [ngValue]="request.id">
                                        {{request.requestType}}</option>
                                </select>
                                <!-- error block -->
                                <div *ngIf="submitted && f.requestTypeId.errors" class="invalid-feedback2">
                                    <div *ngIf="f.requestTypeId.errors.required">Service Name is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="doctypeId" class="form-label">Document Type</label>
                                <select formControlName="doctypeId" class="form-control form-input" id="doctypeId"
                                [(ngModel)]="price.doctypeId">
                                    <option value="undefined" disabled selected> Please select Document Type </option>
                                    <option *ngFor="let request of DocumentTypeDropDown" [ngValue]="request.id">
                                        {{request.documentName}}</option>
                                </select>
                               
                                <div *ngIf="submitted && f.doctypeId.errors" class="invalid-feedback2">
                                    <div *ngIf="f.doctypeId.errors.required">Document Type is required</div>
                                </div>
                            </div>

                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="amount" class="form-label">University Price (<i class="fa fa-inr"
                                        aria-hidden="true"></i>)<span class="color-red">*</span></label>
                                <input type="text" placeholder="Enter the amount for the service"
                                    formControlName="amount" [(ngModel)]="price.amount" class="form-control form-input"
                                    id="amount" appTwoDigitDecimaNumber
                                    [ngClass]="{'is-invalid': submitted && f.amount.errors }" />
                                <div *ngIf="submitted && f.amount.errors" class="invalid-feedback">
                                    <div *ngIf="f.amount.errors.required">Amount is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="securitycharge" class="form-label">Security Charge (<i class="fa fa-inr"
                                        aria-hidden="true"></i>)<span class="color-red">*</span></label>
                                <input type="text" placeholder="Enter the security charge for the service"
                                    formControlName="securitycharge" [(ngModel)]="price.securitycharge"
                                    class="form-control form-input" id="securitycharge" appTwoDigitDecimaNumber
                                    [ngClass]="{'is-invalid': submitted && f.securitycharge.errors }" />
                                <div *ngIf="submitted && f.securitycharge.errors" class="invalid-feedback">
                                    <div *ngIf="f.securitycharge.errors.required">Security Charge is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="gst" class="form-label">gst (<i class="fa fa-inr"
                                        aria-hidden="true"></i>)<span class="color-red">*</span></label>
                                <input type="text" placeholder="Enter the gst for the service" formControlName="gst"
                                    [(ngModel)]="price.gst" class="form-control form-input" id="gst"
                                    appTwoDigitDecimaNumber [ngClass]="{'is-invalid': submitted && f.gst.errors }" />
                                <div *ngIf="submitted && f.gst.errors" class="invalid-feedback">
                                    <div *ngIf="f.gst.errors.required">gst is required</div>
                                </div>

                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="yearrangeStart" class="form-label">Year From</label>
                                <select formControlName="yearrangeStart" class="form-control form-input"
                                    id="yearrangeStart" [(ngModel)]="selectedStartYear"  (change)='onOptionsSelectedStart()'>
                                    <option value="undefined" disabled selected> Please select Year Of
                                        Passing </option>
                                    <option *ngFor="let year of yearrangeStart" [ngValue]="year.id">
                                        {{year.year}}</option>
                                </select>
                                <!-- error block -->
                                <div *ngIf="yearSmallerthan" class="invalid-feedback2">
                                    <div >Year start is smaller than Year to</div>
                                </div>
                                <div *ngIf="submitted && f.yearrangeStart.errors" class="invalid-feedback2">
                                    <div *ngIf="f.yearrangeStart.errors.required">Year From is required</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group input-group-lg">
                                <label for="yearrangeEnd" class="form-label">Year To</label>
                                <select formControlName="yearrangeEnd" class="form-control form-input" id="yearrangeEnd"
                                    [(ngModel)]="selectedEndYear" (change)='onOptionsSelected()'>
                                    <option value="undefined" disabled selected> Please select Year </option>
                                    <option *ngFor="let year of yearrangeEnd" [ngValue]="year.id">
                                        {{year.year}}</option>
                                </select>
                                 <!-- error block -->
                                 <div *ngIf="yearGreaterthan" class="invalid-feedback2">
                                    <div >Year To is greater than Year start</div>
                                </div>
                                 <div *ngIf="submitted && f.yearrangeEnd.errors" class="invalid-feedback2">
                                    <div *ngIf="f.yearrangeEnd.errors.required">Year To is required</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="proceed-btn bg-theme" (click)="addPrice()">Submit</button>
                    <button class="proceed-btn" (click)="goBack()">Cancel</button>
                </form>
            </div>
        </div>
    </div>
</div>

<ng-template #showModalBox class="modal fade " id="successModal" tabindex="-1" role="dialog" let-c="close"
    let-d="dismiss" aria-labelledby="resetPasswordModalLabel" aria-hidden="false">
    <div class="modal-content">
        <div class="modal-header success-modal-header">
            <h5 class="modal-title icon-title" id="resetPasswordModalLabel">
                <span class="icon-wrap bg-theme"><img src="assets/images/thumb-up.png" class="fa-icon-modal" alt="img"></span>
            </h5>
        </div>
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="success-text">Success</h3>
                    <p class="reset-hd2">Price Added Successfully.</p>
                </div>
            </div>
            <button class="approve-modal-btn2 bg-theme mr-auto" data-dismiss="modal" (click)="refresh()">Done</button>
        </div>
    </div>
</ng-template>